import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { RankTransformation } from '../../../dataflow/ranktransformation';
import { BaseSortTransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-sort-transformation.adapter';
import { isTruthy } from 'app/model/dataflow/dataflow-expression-utilities';
import { DataFlowExpressionUtils } from '../expression.util';
import { BooleanDataFlowType } from 'app/model/dataflow/dataflow-datatype';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(RankTransformation),
    asynchronous: true
})
export class RankTransformationAdapter extends BaseSortTransformationAdapter {
    protected getExtraDSLConfigs(rankTransformation: RankTransformation): string[] {
        const column = rankTransformation.keyColumn;
        const rankProps = [`output(${column.serializableColumnName} as ${column.dataFlowColumnType.typeString})`];
        if (isTruthy(rankTransformation.dense)) {
            rankProps.push(
                `dense: ${DataFlowExpressionUtils.wrapExpressionConfigValue(
                    rankTransformation.dense,
                    BooleanDataFlowType.TYPE
                )}`
            );
        }
        return rankProps;
    }
}
